module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "SELECIONE A UNIDADE SOLICITANTE",
      "label": "nome",
      "options": _vm.unidades
    },
    model: {
      value: (_vm.unidadeSelecionada),
      callback: function($$v) {
        _vm.unidadeSelecionada = $$v
      },
      expression: "unidadeSelecionada"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "SELECIONE O PROCEDIMENTO",
      "label": "nome",
      "options": _vm.procedimentos
    },
    model: {
      value: (_vm.procedimentoSelecionado),
      callback: function($$v) {
        _vm.procedimentoSelecionado = $$v
      },
      expression: "procedimentoSelecionado"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Categoria da unidade")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "SELECIONE A CATEGORIA",
      "label": "nome",
      "options": _vm.categorias
    },
    model: {
      value: (_vm.categoriaUnidadeSelecionada),
      callback: function($$v) {
        _vm.categoriaUnidadeSelecionada = $$v
      },
      expression: "categoriaUnidadeSelecionada"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('select-paciente', {
    attrs: {
      "nome-paciente-recuperado": _vm.$store.state.filtrosRegulador.pacienteSelecionado.nome,
      "regulador": true
    },
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Marcador")]), _vm._v(" "), _c('select-marcador', {
    attrs: {
      "nome-marcador-recuperado": _vm.$store.state.filtrosRegulador.marcadorSelecionado.name,
      "regulador": true
    },
    on: {
      "setMarcadorSelecionado": function (marcador) {
        _vm.setMarcadorSelecionado(marcador);
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Data da solicitação (Tempo)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("Tipo Consulta")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                            Solicitante\n                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('H.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'H.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                            Procedimento(s)\n                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('F.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'F.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                            Paciente\n                            "), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('A.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'A.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Idade do paciente")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Marcador")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('router-link', {
      key: item.id,
      staticClass: "even hand",
      attrs: {
        "role": "row",
        "tag": "tr",
        "to": '/atendimentos/regulacao/solicitacao/' + item.id
      }
    }, [_c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(item.id)) + " "), (item.situacao == 6) ? _c('i', {
      staticClass: "fa fa-comments"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("dataFormatadaHora")(item.created_at)) + " (" + _vm._s(_vm._f("diasDaData")(item.created_at)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v("\n                            " + _vm._s(item.codigo + " - " + item.procedimento) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.paciente))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("idade")(item.data_nascimento)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm._f("mesPorExtenso")(item.data_competencia)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.marcador))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c641e8de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/regulacao/tabelaSolicitacoes.vue
// module id = 895
// module chunks = 0